import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';

import { makeGetUpgradeCtaData, makeGetCardTitle } from '../redux';
import { isG171Experiment } from 'src/universal/components/Experiments/G171/redux';

import removeTags from 'service_modules/utils/text-remove-tags';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';

import { Type, Color, Button, Icon } from '@americanexpress/aqx-components';

import styles from '../__styles__/ctas.scss?modules';

const UpgradeCta = ({ upgradeCtaData, cardTitle, isBottomRow, isG171 }) => {
  const { upgradeBtn, needUpgradeCta } = upgradeCtaData;
  const { title, text, url } = upgradeBtn;

  if (!needUpgradeCta) {
    return null;
  }

  const ariaLabel = removeTags(`${text} for ${cardTitle}`);
  const onClick = () =>
    sendDTMClickEvent({ eventAction: 'Click', eventAsset: 'Upgrade_TileMain' });
  return (
    <Button
      Component="a"
      $type={Type.Primary}
      title={title}
      aria-label={ariaLabel}
      href={url}
      onClick={onClick}
      className={clsx(styles.upgradeCta, { [styles.bottomRow]: isBottomRow })}
    >
      {!isG171 && (
        <Icon
          directory="dls"
          imageName="dls-icon-lock"
          theme={{ color: Color.White }}
          className={styles.icon}
        />
      )}
      <Sanitizer safelySetInnerHTML={text} />
    </Button>
  );
};

const mapStateToProps = () => {
  const getUpgradeCtaData = makeGetUpgradeCtaData();
  const getCardTitle = makeGetCardTitle();

  return (state, { shortName }) => ({
    upgradeCtaData: getUpgradeCtaData(state, shortName),
    cardTitle: getCardTitle(state, shortName),
    isG171: isG171Experiment(state)
  });
};

export default connect(mapStateToProps)(UpgradeCta);
